<template>
  <v-container fluid class="otp-page d-flex align-center justify-center">
    <v-card class="otp-card pa-8" elevation="8">
      <h1 class="mb-2">Verify your email</h1>
      <p class="mb-6">
        Enter the 6-digit code sent to {{ pendingEmail }}.
      </p>

      <form @submit.prevent="verifyOtp">
        <label for="otp">Verification code</label>
        <input
          id="otp"
          v-model="code"
          class="otp-input mt-2"
          inputmode="numeric"
          maxlength="6"
          autocomplete="one-time-code"
          :disabled="isVerifying"
          @input="code = code.replace(/\D/g, '').slice(0, 6)"
        />
        <p v-if="errorMessage" class="error-text mt-2">{{ errorMessage }}</p>

        <v-btn
          type="submit"
          class="otp-button mt-6"
          :loading="isVerifying"
          :disabled="code.length !== 6"
          block
        >
          Confirm code
        </v-btn>
      </form>

      <v-btn
        class="mt-4"
        variant="text"
        block
        :loading="isResending"
        :disabled="secondsRemaining > 0"
        @click="resendOtp"
      >
        {{ secondsRemaining > 0 ? `Resend code in ${secondsRemaining}s` : "Resend code" }}
      </v-btn>
      <v-btn class="mt-1" variant="text" block @click="goBack">
        Back to sign in
      </v-btn>
    </v-card>
  </v-container>
</template>

<script>
import { loginForm } from "@/store/logIn";

export default {
  name: "LoginOtp",
  data() {
    return {
      code: "",
      errorMessage: "",
      isVerifying: false,
      isResending: false,
      secondsRemaining: 60,
      timer: null,
      loginStore: loginForm(),
    };
  },
  computed: {
    pendingEmail() {
      return this.loginStore.pendingLogin?.email || "your email address";
    },
  },
  methods: {
    startTimer() {
      clearInterval(this.timer);
      this.secondsRemaining = 60;
      this.timer = setInterval(() => {
        if (this.secondsRemaining <= 1) {
          clearInterval(this.timer);
          this.timer = null;
          this.secondsRemaining = 0;
          return;
        }
        this.secondsRemaining -= 1;
      }, 1000);
    },
    async verifyOtp() {
      this.errorMessage = "";
      this.isVerifying = true;
      const result = await this.loginStore.verifyLoginOtp(this.code);
      this.isVerifying = false;
      if (!result.success) {
        this.errorMessage = result.message;
      }
    },
    async resendOtp() {
      this.errorMessage = "";
      this.isResending = true;
      const result = await this.loginStore.resendLoginOtp();
      this.isResending = false;
      if (result.success) {
        this.startTimer();
      } else {
        this.errorMessage = result.message;
      }
    },
    goBack() {
      this.loginStore.clearPendingLogin();
      this.$router.replace({ name: "LoginPage" });
    },
  },
  mounted() {
    if (!this.loginStore.pendingLogin) {
      this.$router.replace({ name: "LoginPage" });
      return;
    }
    this.startTimer();
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
.otp-page {
  min-height: 100vh;
  background: rgba(239, 248, 255, 1);
}
.otp-card {
  width: min(100%, 440px);
  border-radius: 16px;
}
.otp-input {
  width: 100%;
  height: 52px;
  border: 1px solid rgba(102, 102, 102, 0.35);
  border-radius: 12px;
  font-size: 24px;
  letter-spacing: 0.5em;
  padding: 0 16px;
  text-align: center;
}
.otp-button {
  background: linear-gradient(90deg, #1f666a 0%, #4f979f 100%);
  color: white;
  min-height: 52px;
}
.error-text {
  color: #b3261e;
}
</style>
